
import { DashboardContent } from "./dashboard-content";

export default function Dashboard() {
  return <DashboardContent />;
}
